var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"blockContato"}},[(_vm.textBlock != undefined)?_c('TextoSimples',{attrs:{"content":_vm.textBlock}}):_vm._e(),_c('FormularioContato',{attrs:{"content":_vm.formBlock}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }